import { useQuery } from '@tanstack/react-query';

/**
 * R13 A-2: 공개 브랜드 목록. 상품 등록/수정 폼의 브랜드 선택기 데이터 소스.
 *
 * BE 계약(be-catalog): `GET /api/v1/catalog/brands` → `{ brands: [{ brandId, brandName, slug }] }`
 * (brandName 오름차순). 브랜드는 비민감 마스터 데이터(상품 상세에 이미 브랜드명이 공개)라
 * permitAll 비인증 접근이며, 게이트웨이 broad route(`/api/v1/catalog/**`)로 라우팅된다(무변경).
 *
 * A-2 회귀 원인: 이전엔 브랜드 목록 엔드포인트가 없어 폼이 유효한 brandId 를 선택할 수단이
 * 없었고 → 생성 시 brandId 누락 → brand_id=NULL → 상세/미리보기 브랜드 칸 공백.
 * 이 목록으로 폼이 유효한 brandId 를 선택·전송하게 한다.
 */

export interface BrandItem {
  brandId: string;
  brandName: string;
  slug: string;
}

interface BrandsEnvelope {
  success: boolean;
  data?: { brands: BrandItem[] } | null;
}

const fetchBrands = async (): Promise<BrandItem[]> => {
  // 공개 엔드포인트 — 인증 불필요하므로 adminFetch(인증·401 갱신)를 쓰지 않는다.
  const res = await fetch('/api/v1/catalog/brands');
  if (!res.ok) throw new Error(`brands fetch failed: ${res.status}`);
  const env = (await res.json()) as BrandsEnvelope;
  return env.data?.brands ?? [];
};

export const brandsQueryKey = () => ['public', 'brands'] as const;

export const useBrandsQuery = () =>
  useQuery<BrandItem[]>({
    queryKey: brandsQueryKey(),
    queryFn: fetchBrands,
    staleTime: 5 * 60 * 1000,
  });
